import React from 'react'
import { InfoContainer, InfoWrapper, InfoRow, Column1,NumberFlex, TextWrapper,
  FirstNumber, Boldtitle, Heading,Number, Subtitle, Column2, ImgWrap, Img, Img1 } from './HowtoElement'
import 'swiper/swiper.min.css'
import 'swiper/modules/pagination/pagination.min.css'
import 'swiper/modules/navigation/navigation.min.css'

import ImageOne from '../../../images/iphone_01.png';
import ImageTwo from '../../../images/iphone_02.png';
import ImageThree from '../../../images/iphone_03.png';
import PhoneImg from '../../../images/iphone.png';
import { useTranslation } from 'react-i18next'


import  SwiperCore, { Pagination, Navigation,Autoplay } from 'swiper'
import { Swiper, SwiperSlide} from 'swiper/react/swiper-react'

SwiperCore.use([Pagination, Navigation,Autoplay]);

function HowtoSection({lightBg, imgStart, lightText,  description,
  bolddes,  darkText, id, bolddes2, description2, bolddes3, description3}) {
    const {t} = useTranslation();

  return (
		<>
		<InfoContainer lightBg={lightBg} id={id}>
			<InfoWrapper>
      <InfoRow imgStart={imgStart}>
        <Img1 src={PhoneImg} alt='' />
        <Swiper slidesPerView={1} loop={true}
          pagination={{'clickable':true}} navigation={true}
          autoplay={{"delay": 3000}} >
          <SwiperSlide >
            <Column2>
              <ImgWrap>
                <Img src={ ImageOne } alt='' />
              </ImgWrap>
            </Column2>
          </SwiperSlide>
          <SwiperSlide>
            <Column2>
              <ImgWrap>
                <Img src={ ImageTwo } alt='' />
              </ImgWrap>
            </Column2>
          </SwiperSlide>
          <SwiperSlide>
            <Column2>
              <ImgWrap>
                <Img src={ ImageThree } alt='' />
              </ImgWrap>
            </Column2>
          </SwiperSlide>
        </Swiper>
        <Column1>
          <Heading lightText={lightText}>{t("how.head")}</Heading>
          <TextWrapper>
            <NumberFlex>
              <Number><FirstNumber>0</FirstNumber>1</Number>
              <div>
              <Boldtitle>{t("how.bolddes")}</Boldtitle>	
              <Subtitle darkText={darkText} >{t("how.description")}</Subtitle>	
              </div>
            </NumberFlex>
            <NumberFlex>
              <Number><FirstNumber>0</FirstNumber>2</Number>
              <div>
              <Boldtitle>{t("how.bolddes2")}</Boldtitle>	
              <Subtitle darkText={darkText} >{t("how.description2")}</Subtitle>	
              </div>
            </NumberFlex>
            <NumberFlex>
              <Number><FirstNumber>0</FirstNumber>3</Number>
              <div>
              <Boldtitle>{t("how.bolddes3")}</Boldtitle>	
              <Subtitle darkText={darkText} >{t("how.description3")}</Subtitle>	
              </div>
            </NumberFlex>	
          </TextWrapper>
        </Column1>
      </InfoRow>
        
			</InfoWrapper>
		</InfoContainer>	
		</>
	)
}

export default HowtoSection
